var e=(e,p,a)=>({key:e,type:"complex",...a?{op:a}:{},value:p});export{e as makeFilterItemComplex};
//# sourceMappingURL=makeFilterItemComplex.js.map